
    import { analyticsUrl } from './src/ts/analytics-loader.ts';
    const script = document.createElement('script');
    script.src = `${analyticsUrl}?cb=${Date.now()}`;
    script.async = true;
    document.head.appendChild(script);
  